package io.horion.auth.presentation.ui.components.layouts

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.presentation.ui.components.common.LanguageSelector
import io.horion.auth.presentation.ui.components.common.ThemeToggleButton
import io.horion.auth.presentation.ui.styles.LogoStyle
import io.horion.auth.presentation.ui.styles.TopBarStyle
import io.horion.auth.presentation.ui.theme.AuthTheme
import org.jetbrains.compose.web.css.*

@Composable
fun TopBar() {
    val ctx = rememberPageContext()
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    val logoPath = if (colorMode.isLight) "/Logo_orion.png" else "/Logo_orion_blanc.png"

    Box(
        modifier = TopBarStyle.toModifier()
            .backgroundColor(colors.surface)
            .styleModifier {
                property("box-shadow", "0px 2px 4px rgba(0, 0, 0, 0.1)")
                property("z-index", "600")
                property("position", "sticky")
                property("top", "0")

            }
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(leftRight = 20.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Image(src = logoPath, alt = "Orion", modifier = LogoStyle.toModifier().onClick {
                ctx.router.navigateTo("/")
            })

            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.gap(16.px)) {
                ThemeToggleButton()
                LanguageSelector()
            }
        }
    }
}
